import { lazy } from "react"

const PartySecretsPage$$__react__lazy__component = lazy(() => 
    import("./PartySecretsPage__original__module.mjs")
        .then(module => module.get_$$PartySecretsPage$$PartySecretsPage$$react__component$$1e02htfrmrf5p())
        .then(component => ({ default: component }))
)

export const get_$$PartySecretsPage$$PartySecretsPage$$react__component$$1e02htfrmrf5p = () => PartySecretsPage$$__react__lazy__component